<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">Doubt is not a pleasant mental state</p>
<p class="fm1">but certainty is a ridiculous one.</p>
<p class="fm4">—V<span class="smallcaps">OLTAIRE</span></p>
<p class="fm3">To die for an idea</p>
<p class="fm1">is to pay a high price for conjecture.</p>
<p class="fm2">—A<span class="smallcaps">NATOLE</span> F<span class="smallcaps">RANCE</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?4aaec898